import { Buttons, PaginationFraction, Scroller, Slider, Overlay as SliderOverlay } from '@cian/slider';

import { type FC } from 'react';

import { type CarouselProps } from '../../types';

import { SlideImage } from './internal/components/SlideImage';
import { SlideImageWithOverlay } from './internal/components/SlideImageWithOverlay';

export const Carousel: FC<CarouselProps> = props => {
  const { media, getIsDeoptimised, withControls = true, withCount = true, onSlideChange } = props;

  return (
    <Slider loop onSlideChange={onSlideChange}>
      <Scroller>
        {media.map((item, index) => {
          const isDeoptimised = !!getIsDeoptimised?.(item, index);

          if (item.overlay) {
            return (
              <SlideImageWithOverlay
                alt={item.alt}
                background={item.overlay.background}
                content={item.overlay.content}
                isDeoptimised={isDeoptimised}
                key={item.id}
                src={item.src}
              />
            );
          }

          return <SlideImage alt={item.alt} isDeoptimised={isDeoptimised} key={item.id} src={item.src} />;
        })}
      </Scroller>
      {(withControls || withCount) && (
        <SliderOverlay>
          {withControls && <Buttons size="M" />}
          {withCount && (
            <span data-testid="card-gallery.pagination">
              <PaginationFraction />
            </span>
          )}
        </SliderOverlay>
      )}
    </Slider>
  );
};
